import { Injectable, SkipSelf } from '@angular/core';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { EnvService } from 'src/app/env.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiEndPointsCore } from '../../common/apiUrls/api-end-points-core';

@Injectable({
  providedIn: 'root'
})
export class CoreService {
  private baseUrl:any;
  private baseUrlClm:any;
  private baseUrlTran:any;
  constructor(@SkipSelf()private _http: HttpClient, 
  private apiAddress: ApiEndPointsCore, public env: EnvService,
    private constant: Constants) {
      if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
      this.baseUrl = this.constant.ManageContactsportNumber;
 else
      this.baseUrl = this.env.apiUrl+this.constant.ManageContactsportNumber;
     
     
      if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
      this.baseUrlClm = this.constant.CustomizedGridComponentPortNumber;
 else
      this.baseUrlClm = this.env.apiUrl+this.constant.CustomizedGridComponentPortNumber;
     
      if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
      this.baseUrlTran = this.constant.ManageTranscationportNumber;
 else
      this.baseUrlTran = this.env.apiUrl+this.constant.ManageTranscationportNumber;
     
     
  }
    // private baseUrl = this.env.apiUrl+this.constant.ManageCoreportNumber;
    // private baseUrl = this.constant.ManageCoreportNumber;
    // private baseUrlClm = this.constant.CustomizedGridComponentPortNumber;
    // //private baseUrlClm = this.env.apiUrl+this.constant.CustomizedGridComponentPortNumber;
    // //private baseUrlTran = this.env.apiUrl+this.constant.ManageTranscationportNumber;
    // private baseUrlTran = this.constant.ManageTranscationportNumber;
    getCoreList(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddress.getCoreListing;
      return this._http.post(apiURL, reqModel).pipe();
    } 
    
    getFilteredCoresList(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddress.GetFilteredCores;
      return this._http.post(apiURL, reqModel).pipe();
    }
    
    getCoreUserDetails(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddress.getCoreUserDetails;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getCoreFeildList(reqModel): Observable<any> {
      const apiURL = this.baseUrl + this.apiAddress.getCoreFeildList;
      return this._http.post(apiURL, reqModel).pipe();
    }

    geDefaultFilterFieldsList(reqModel): Observable<any> {
      const apiURL = this.baseUrlClm + this.apiAddress.getDefaultFilterFieldsList;
      return this._http.post(apiURL, reqModel).pipe();
    }

    CreateFilter(reqModel): Observable<any> {
      const apiURL = this.baseUrlClm + this.apiAddress.CreateFilter;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getImageUlpoadURL(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddress.getImageUploadURL;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getCoreFieldColumnList(reqModel): Observable<any> {
      const apiURL = this.baseUrlClm + this.apiAddress.getCoreFieldColumn;
      return this._http.post(apiURL, reqModel).pipe();
    }
 
    
    getAllCoreTypeFilterList(reqModel): Observable<any> {
      const apiURL = this.baseUrlClm + this.apiAddress.GetAllFillters;
      return this._http.post(apiURL, reqModel).pipe();
    }

    updateCoreFieldColumnList(reqModel): Observable<any> {
      const apiURL = this.baseUrlClm + this.apiAddress.updateCoreFieldColumn;
      return this._http.post(apiURL, reqModel).pipe();
    }

    ReorderCoreFieldColumnList(reqModel): Observable<any> {
      const apiURL = this.baseUrlClm + this.apiAddress.ReorderCoreFieldColumn;
      return this._http.post(apiURL, reqModel).pipe();
    }

    saveCoreFeildList(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddress.saveCoreFieldList;
      return this._http.post(apiURL, reqModel).pipe();
    }
    saveCoreUserDetails(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddress.saveCoreUserDetails;
      return this._http.post(apiURL, reqModel).pipe();
    }

    AddContactTouch(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddress.AddContactTouch;
      return this._http.post(apiURL, reqModel).pipe();
    }
   
    GetAllContactTouchess(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddress.GetAllContactTouchess;
      return this._http.post(apiURL, reqModel).pipe();
    }
}
